module.exports = __webpack_public_path__ + "img/m2.5ad7fa0c.png";